/**
 * How far up the readiness ladder a programme has climbed.
 *
 * @module components/shared/ReadinessBadge
 */

import React from "react";

import { readinessTone } from "@/components/shared/status-tones";
import { TONE_BADGE, TONE_ICON } from "@/components/shared/tone-presentation";
import { Badge, Icon } from "@/components/ui";
import type { ReadinessState } from "@/server/types/readiness";

export interface ReadinessBadgeProps {
  state: ReadinessState;
  size?: "xs" | "sm" | "md";
  "data-testid"?: string;
}

export function ReadinessBadge({
  state,
  size = "md",
  "data-testid": testId,
}: ReadinessBadgeProps): React.ReactElement {
  const tone = readinessTone(state);
  return (
    <Badge tone={TONE_BADGE[tone]} size={size} data-testid={testId}>
      <Icon name={TONE_ICON[tone]} aria-hidden />
      {state}
    </Badge>
  );
}

export default ReadinessBadge;
